import { Button } from '@material-ui/core';
import * as React from 'react';
import { AdvancedBloc } from '../AdvancedBloc';
import { IComponentProps } from './CleanMatch.connector';
import {getProject} from "../../../../../common/services/project";

export class CleanMatch extends React.Component<IComponentProps> {
  public state = {
    isRequesting: false,
  };

  public render() {
    const {
      intl: { messages: m },
      mainCommentatorLocale,
    } = this.props;
    const { isRequesting } = this.state;
    return (
      <AdvancedBloc
        title={m.live_advanced_cleanTitle}
        description={m.live_advanced_cleanDescription}
      >
        <Button
            color="primary"
            onClick={this.handleClick}
            disabled={isRequesting || mainCommentatorLocale != getProject().lang}
        >
          {m.button_cleanMatch}
        </Button>
      </AdvancedBloc>
    );
  }

  private handleClick = () => {
    this.setState({ isRequesting: true });
    // @ts-ignore dispatch type error
    this.props.cleanMatch().then(() => this.setState({ isRequesting: false }));
  };
}
